import { ChangeDetectorRef } from "@angular/core";
import {
	Output,
	EventEmitter,
	Input,
	ViewChild,
	ElementRef,
} from "@angular/core";
import { Component } from "@angular/core";
import { ScreenControllerService } from "../../controls/screen-controller.service";
import { BaseView } from "../base-view";
import { ModalPopupService } from "../../../services/modal-popup.service";
import { Subscription } from "rxjs";
import { DescriptorModelService } from "../../models/descriptor-model.service";
import { UtilityScripts } from "app/helpers/utility-scripts";
import { ApplicationModel } from "app/core/models/application.model";
import { CourseTimerService } from "app/services/course-timer.service";
import { CourseContextModelService } from "../../models/course-context-model.service";
import { TrackingManager } from "app/core/tracking/tracking-manager";
import { CourseControllerService } from "app/core/controls/course-controller.service";
@Component({
	selector: "app-app-right-container",
	templateUrl: "./app-right-container.component.html",
	styleUrls: [
		"../../../app.component.css",
		"./app-right-container.component.css",
	],
})
export class AppRightContainerComponent extends BaseView {
	private definitionText = { title: "", bodyText: "" };
	private smallMenuOpen: boolean;
	private popupSubscriber: Subscription;
	public isRubricLoaded: Boolean = false;
	public docOpen: boolean;
	public srcString: string;
	private courseTimeSubscription: Subscription;
	public bShowCourseTime: boolean = false;
	// public arrScreen: Array<screen>;
	@Input() sidebar_inner_wrap: string;
	@Output() closeSidebar: EventEmitter<string> = new EventEmitter();
	@Output() presMode: EventEmitter<string> = new EventEmitter();
	@Output() changeRoute: EventEmitter<string> = new EventEmitter();
	@ViewChild("backdrop", { static: true }) backdrop: ElementRef;

	constructor(
		private screenController: ScreenControllerService,
		public courseControllerService: CourseControllerService,
		private cdr: ChangeDetectorRef,
		private courseContextModelService: CourseContextModelService,
		private modalPopupService: ModalPopupService,
		public descriptorService: DescriptorModelService,
		private courseTimer: CourseTimerService
	) {
		super();
		this.smallMenuOpen = false;
		this.courseTimeSubscription = this.courseTimer.notifier.subscribe(
			(data) => {
				if (data.available) {
					this.bShowCourseTime = data.available;
				}
			}
		);
	}
	ngDoCheck() {
		this.cdr.detectChanges();
	}
	ngAfterViewInit() {
		this.smallMenuOpen =
			getComputedStyle(this.backdrop.nativeElement, null).getPropertyValue(
				"display"
			) === `inherit`
				? true
				: false;
	}

	public triggerRubricComplete(event: string) {
		this.screenController.activeContinue = event === "continue";
		if (!this.screenController.activeContinue) {
			this.screenController.triggerRubricComplete(event);
		}
	}

	public showDefintion(id) {
		let popupdata: any = {
			size: "lg",
			showClose: true,
			buttonLabel:
				this.screenController.descriptorModel.getDescriptorTextById(
					"close_str"
				),
			title: this.screenController.definitionModel.getTermById(id),
			bodyText: this.screenController.definitionModel.getDefinitionById(id),
		};
		this.modalPopupService.openPopup(popupdata);
		//this.popupSubscriber = this.modalPopupService.ClosePopup.subscribe(data => this.closeDefinitionPopup());
	}
	public jumpToPage(pageId: string) {
		this.screenController.jumpToPage(pageId);
	}
	/*public closeDefinitionPopup() {
    this.popupSubscriber.unsubscribe();
    this.definitionText.bodyText = '';
    this.definitionText.title = '';
  }*/
	public onNavigate(evt) {
		this[evt]();
	}
	private next() {
		let nextExpectedRubricName = UtilityScripts.getRubricName(
			this.courseContextModelService.currentRubric().coursePage.page_rubric
		);
		if (
			TrackingManager.instance.trackingVO.lessonStatus ==
			TrackingManager.instance.config.completedVal
		) {
			this.isRubricLoaded = false;
			this.screenController.next();
		} else if (
			(nextExpectedRubricName != "certificate" &&
				nextExpectedRubricName != "certificate_adaptive") ||
			this.courseTimer.minimumTimeint <= 0
		) {
			this.isRubricLoaded = false;
			this.screenController.next();
		} else {
			if (!this.courseTimer.isTimeMet()) {
				ApplicationModel.instance.bLastPageReached = true;
				//
				let popupdata: any = {
					size: "lg",
					showClose: true,
					buttonLabel:
						this.screenController.descriptorModel.getDescriptorTextById(
							"close_str"
						),
					title:
						this.screenController.descriptorModel.getDescriptorTextById(
							"timerSummaryHeader"
						),
					bodyText:
						this.screenController.descriptorModel.getDescriptorTextById(
							"timerSummary1"
						),
				};
				this.modalPopupService.openPopup(popupdata);
			} else {
				this.isRubricLoaded = false;
				this.screenController.next();
			}
		}
		//ApplicationModel.instance.nextExpectedRubric = UtilityScripts.getRubricName(this.courseContextModelService.nextExpectedRubric().coursePage.page_rubric);
	}
	private back() {
		this.isRubricLoaded = false;
		this.screenController.back();
	}
	private continue() {
		this.screenController.pageContinue = true;
		this.screenController.activeContinue = false;
	}
	public resetContinue() {
		this.screenController.activeContinue = false;
	}
	public get print_label(): string {
		return this.descriptorService.getDescriptorTextById("print_str");
	}
	public get continue_label(): string {
		return this.descriptorService.getDescriptorTextById("continue_str");
	}

	public get screenControllerVal(): ScreenControllerService {
		return this.screenController;
	}
	public get docUrl(): string {
		return UtilityScripts.getDocumentURL(this.screenController.documentContent);
	}

	public currPresentationMode(): string {
		if (
			this.screenController.selectedPresentationMode &&
			this.screenController.selectedPresentationMode.mode
		) {
			return this.screenController.selectedPresentationMode.mode;
		} else {
			return ``;
		}
	}

	public courseStructureModelDocs(): any {
		return this.screenController.courseStructureModelDocs;
	}

	public modeSelect(pMode: string) {
		this.presMode.emit(pMode);
	}

	public contentBackdropClick(event) {
		this.closeSidebar.emit(`page-inner-wrap toggled`);
	}
	public activateButtonEvent(event: string) {
		this.screenController.activateIagreeButton = event === "iagree";
	}
	public iAgreeBtnClick() {
		this.screenController.activateIagreeButton = false;
		this.screenController.next();
	}

	public triggerAutoTransition(event: boolean) {
		this.screenController.next();
	}

	public loadRubric(rubricName) {
		this.changeRoute.emit(rubricName);
	}
	public rubricLoaded(event: string) {
		this.isRubricLoaded = true;
	}
	public closeWin() {
		this.docOpen = false;
		this.srcString = "";
		// if (this.model.arrScreen.find(screen => screen.viewed === false) === undefined) {
		//   this.rubricCompleted();
		// }
	}

	public print() {
		let printContents, popupWin;
		var parentClass = this;
		printContents = document.getElementById("printDoc1");
		printContents.contentWindow.print();
		/*popupWin = window.open('','height=100%,width=auto,text-align=center');
    popupWin.document.write(`
      <body><h3>Loading Document for printing, please wait...</h3></body>
      </html>`
    );    
  
    html2canvas(printContents).then(function(canvas) {      
      var myImage = canvas.toDataURL("image/png");
      document.body.appendChild(canvas);
      parentClass.sendForPrinting(canvas, popupWin);
    });    */
	}
	public sendForPrinting(canvas, popupWin) {
		popupWin.document.body.removeChild(popupWin.document.body.firstChild);
		popupWin.document.body.appendChild(canvas);
		popupWin.print();
		popupWin.close();
	}
	public documentLoadHandler(zoomLevel: number = 1) {
		var iframe: any = window.document.getElementById("printDoc1");
		var document = iframe.contentWindow.document;
		document.body.style.zoom = zoomLevel;
		UtilityScripts.addScroll(document);
	}
}
